import axios from 'axios';
import { Message } from 'element-ui'; // 可选：用于错误提示

// 创建axios实例
const service = axios.create({
    timeout: 10000, // 统一超时时间（和Uniapp一致）
    headers: {
        'Content-Type': 'application/json' // 请求头和Uniapp一致
    }
});

// 基础请求封装函数
export default function request(data, urlSuffix) {
    // 统一请求前缀（和Uniapp完全一致）
    const baseUrl = process.env.NODE_ENV === 'development' ? `/api/${urlSuffix}` : `https://app.starpeakstudios.cn:8030/${urlSuffix}`;
    // 测试环境地址（按需切换）
    // const baseUrl = `https://192.168.254.202:8030/${urlSuffix}`;

    return new Promise((resolve, reject) => {
        service({
            url: baseUrl,
            method: "POST",
            data: data,
        })
            .then((res) => {
                // 统一响应处理（和Uniapp逻辑对齐）
                if (res.status === 200) {
                    resolve(res.data);
                } else {
                    reject(new Error(`请求失败：${res.status}`));
                }
            })
            .catch((err) => {
                // 统一错误提示（替换为Vue的提示组件）
                Message({
                    message: '网络错误',
                    type: 'error',
                    duration: 3000
                });
                // 如果用Element UI 2.x：
                // Message.error('网络错误');

                reject(err);
            });
    });
}

// 可选：请求拦截器（如需添加token等可在这里配置）
service.interceptors.request.use(
    (config) => {
        // 可添加请求头token等逻辑
        // config.headers['Authorization'] = localStorage.getItem('token');
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 可选：响应拦截器（统一处理全局错误）
service.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // 可添加401/403/500等状态码的统一处理
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    Message.error('登录状态过期，请重新登录');
                    // 可添加跳转到登录页的逻辑
                    break;
                case 500:
                    Message.error('服务器内部错误');
                    break;
            }
        }
        return Promise.reject(error);
    }
);